<template>
  <CustomModal
    :isModalOpen="isOpen"
    @toggleModal="$emit('cancel')"
    @onClickAway="$emit('cancel')"
    :overlay="'dark'"
    :with-footer="true"
    :noPadding="true"
    custom-classes="tw:h-screen tw:md:h-auto tw:w-[100vw] tw:md:max-w-[780px] tw:md:w-[780px] tw:md:rounded-xl tw:rounded-none tw:overflow-hidden"
  >
    <template #modalHeader>
      <h2 class="tw:text-xl tw:font-bold tw:text-gray-900">
        {{ $t('pro_plus_header') }}
      </h2>
    </template>

    <div class="tw:px-6 tw:pt-6">
      <ProToPlusReactivationContent
        :isPriceLoading="isPriceLoading"
        :plusMonthlyPrice="plusMonthlyPrice"
        :annualPrice="annualPrice"
        :proPrice="proPrice"
        :isPricingComparison="isPricingComparison"
        :monthlySavings="monthlySavings"
      />
    </div>

    <template #modalFooter>
      <div class="tw:w-full tw:flex tw:justify-end">
        <MainButton @click="$emit('confirm')">
          {{ $t('reactivate_plus_subscription_cta') }}
        </MainButton>
      </div>
    </template>
  </CustomModal>
</template>

<script setup>
import CustomModal from '@/components/base/CustomModal.vue'
import MainButton from '@/components/base/buttons/MainButton.vue'
import ProToPlusReactivationContent from '@/components/billing/premiumProducts/reactivation/ProToPlusReactivationContent.vue'

defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
  isPriceLoading: {
    type: Boolean,
    default: false,
  },
  plusMonthlyPrice: {
    type: Number,
    default: 0,
  },
  annualPrice: {
    type: Number,
    default: 0,
  },
  proPrice: {
    type: Number,
    default: 0,
  },
  isPricingComparison: {
    type: Boolean,
    default: false,
  },
  monthlySavings: {
    type: Number,
    default: 0,
  },
  activationDate: {
    type: String,
    default: null,
  },
})

defineEmits(['confirm', 'cancel'])
</script>
